import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import { LearningCollectionSummaryResource } from '../../Types';
import Experiences from './Experiences';
import LastRegistrationDate from './LastRegistrationDate';
import StudentMembers from './StudentMembers';

interface Props {
  learningCollectionSummaryResource: LearningCollectionSummaryResource;
}

function LearningCollection({ learningCollectionSummaryResource }: Props) {
  const { experiencesCount, studentMembersCount, lastRegistrationDate } =
    learningCollectionSummaryResource.payload;
  return (
    <div className="mt-6 basis-1/2">
      <p className="mb-2 text-sm font-semibold text-gray-500">
        <T kind="Metrics" />
      </p>
      <div className="flex flex-col md:flex-row">
        <Experiences experiencesCount={experiencesCount} />
        <StudentMembers studentMembersCount={studentMembersCount} />
        <LastRegistrationDate lastRegistrationDate={lastRegistrationDate} />
      </div>
    </div>
  );
}

export default observer(LearningCollection);
